import React from 'react';
import FormInput from 'components/Input/FormInput';

interface IProps {
	setMixpanelToken: (value: string) => void;
}

export const MixpanelTokenField: React.FC<IProps> = React.memo(({ setMixpanelToken }) => {
	return (
		<FormInput
			testId="MixpanelTokenField"
			name="mixpanelToken"
			label="mixpanelTokenLabel"
			placeholder="mixpanelTokenPlaceholder"
			onChange={setMixpanelToken}
		/>
	);
});
